/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Chip } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function PrepareView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '1440px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
        gap: '14px',
        alignItems: 'stretch',
      }}
    >
      {' '}
      <div
        style={{ gridColumn: '1/-1', display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {' '}
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--amb) 50%, transparent)',
              background: 'color-mix(in srgb, var(--amb) 10%, transparent)',
              color: 'var(--amb)',
            }}
          >
            <i className="ph ph-sun" style={{ fontSize: '13px' }}></i>Session Setup
          </span>{' '}
          <i className="ph ph-arrow-right" style={{ color: 'var(--ghost)', fontSize: '12px' }}></i>{' '}
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '11.5px',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid var(--l8)',
              color: 'var(--faint)',
            }}
          >
            <i className="ph ph-circle" style={{ fontSize: '12px' }}></i>Trade Execution
          </span>{' '}
          <i className="ph ph-arrow-right" style={{ color: 'var(--ghost)', fontSize: '12px' }}></i>{' '}
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '11.5px',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid var(--l8)',
              color: 'var(--faint)',
            }}
          >
            <i className="ph ph-moon" style={{ fontSize: '12px' }}></i>Session Close
          </span>{' '}
        </div>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        <button
          className="scp-2223d55"
          onClick={m.briefHistoryGo}
          title="Past days live in the End-of-Day reports"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '11.5px',
            padding: '7px 14px',
            borderRadius: '99px',
            border: '1px solid var(--l12)',
            background: 'transparent',
            color: 'var(--text-mid)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-clock-counter-clockwise" style={{ fontSize: '13px' }}></i>Show History
        </button>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}
        >
          <i className="ph ph-brain" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>Mental State
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          How are you feeling before the session?
        </div>{' '}
        <div
          style={{
            fontSize: '9px',
            letterSpacing: '0.11em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
            marginTop: '14px',
          }}
        >
          Mood
        </div>{' '}
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          {' '}
          {(m.moods ?? []).map((m, i31) => (
            <Fragment key={i31}>
              {' '}
              <button
                className="scp-8d13e13"
                onClick={m?.go}
                style={dc.css(
                  `display:flex;flex-direction:column;align-items:center;gap:5px;padding:11px 0;width:76px;border-radius:12px;border:1px solid ${dc.s(m?.bd)};background:${dc.s(m?.bg)};color:${dc.s(m?.fg)};cursor:pointer`,
                )}
              >
                <i className={`ph ${dc.s(m?.icon)}`} style={{ fontSize: '19px' }}></i>
                <span style={{ fontSize: '10.5px', fontWeight: '500' }}>{dc.t(m?.label)}</span>
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--text-mid)', marginTop: '18px' }}>
          {dc.t(m.energyLabel)}
        </div>{' '}
        <input
          type="range"
          min="1"
          max="10"
          value={dc.v(m.energy)}
          onChange={m.setEnergy}
          style={dc.css(`width:100%;margin-top:10px;--fill:${dc.s(m.energyFill)}`)}
          aria-label="Energy level"
        />{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}
        >
          <i className="ph ph-target" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>Session Parameters
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          Set your goals and limits for today
        </div>{' '}
        <div
          style={{
            fontSize: '9px',
            letterSpacing: '0.11em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
            marginTop: '14px',
          }}
        >
          Daily goal
        </div>{' '}
        <input
          placeholder="Execute 2 clean setups with discipline"
          aria-label="Daily goal"
          value={dc.v(m.briefGoal)}
          onChange={(e) => m.briefSetGoal?.(e.target.value)}
          title="Your stated intention for the day — the enforced caps are the Risk Controls below"
          style={{
            width: '100%',
            marginTop: '6px',
            padding: '9px 13px',
            borderRadius: '9px',
            border: '1px solid var(--l10)',
            background: 'var(--fill)',
            color: 'var(--text)',
            fontSize: '12px',
            outline: 'none',
          }}
        />{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
            gap: '12px 10px',
            marginTop: '14px',
          }}
        >
          {' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              Max trades
            </div>
            <input
              value={dc.v(m.briefMaxTradesMirror)}
              aria-label="Max trades"
              aria-describedby="pf-max-trades-mirror-note"
              title="Mirrors the Daily Trade Limit risk control — change it there; the funnel enforces that number"
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '8px 12px',
                borderRadius: '9px',
                border: '1px solid var(--l10)',
                background: 'var(--fill)',
                color: 'var(--text)',
                fontSize: '12px',
                outline: 'none',
                fontVariantNumeric: 'tabular-nums',
              }}
              readOnly
            />
          </div>{' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              Max daily loss ($)
            </div>
            <input
              placeholder="0.00"
              aria-label="Max daily loss in dollars"
              value={dc.v(m.briefMaxLoss)}
              onChange={(e) => m.briefSetMaxLoss?.(e.target.value)}
              title="Part of your daily brief — the enforced loss limit is the Daily Loss Limit risk control"
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '8px 12px',
                borderRadius: '9px',
                border: '1px solid var(--l10)',
                background: 'var(--fill)',
                color: 'var(--text)',
                fontSize: '12px',
                outline: 'none',
                fontVariantNumeric: 'tabular-nums',
              }}
            />
          </div>{' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              Profit target ($)
            </div>
            <input
              placeholder="0.00"
              aria-label="Profit target in dollars"
              value={dc.v(m.briefTarget)}
              onChange={(e) => m.briefSetTarget?.(e.target.value)}
              title="Part of your daily brief — a stated target, not an enforced cap"
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '8px 12px',
                borderRadius: '9px',
                border: '1px solid var(--l10)',
                background: 'var(--fill)',
                color: 'var(--text)',
                fontSize: '12px',
                outline: 'none',
                fontVariantNumeric: 'tabular-nums',
              }}
            />
          </div>{' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              Max position size
            </div>
            <input
              placeholder="lots"
              aria-label="Max position size in lots"
              value={dc.v(m.briefLots)}
              onChange={(e) => m.briefSetLots?.(e.target.value)}
              title="Part of your daily brief — position sizing is checked by the order desk's own risk calculator"
              style={{
                width: '100%',
                marginTop: '6px',
                padding: '8px 12px',
                borderRadius: '9px',
                border: '1px solid var(--l10)',
                background: 'var(--fill)',
                color: 'var(--text)',
                fontSize: '12px',
                outline: 'none',
                fontVariantNumeric: 'tabular-nums',
              }}
            />
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}
        >
          <i className="ph ph-lightning" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>Focus Areas
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          What will you concentrate on today?
        </div>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
          {' '}
          {(m.focusChips ?? []).map((f, i32) => (
            <Fragment key={i32}>
              {' '}
              <Chip bd={f?.bd} bg={f?.bg} fg={f?.fg} onClick={f?.go} hoverClass="scp-2223d55">
                {dc.t(f?.label)}
              </Chip>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          gridColumn: '1/-1',
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '500' }}
        >
          <i className="ph ph-strategy" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>Strategies
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          Which playbook setups are you trading today?
        </div>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
          {' '}
          {(m.stratChips ?? []).map((s, i33) => (
            <Fragment key={i33}>
              {' '}
              <Chip bd={s?.bd} bg={s?.bg} fg={s?.fg} onClick={s?.go} hoverClass="scp-2223d55">
                {dc.t(s?.label)}
              </Chip>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          gridColumn: '1/-1',
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {' '}
          <i className="ph ph-shield-check" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>{' '}
          <span style={{ fontSize: '13px', fontWeight: '500' }}>Rules Review</span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              m.goRiskRules?.();
            }}
            style={{ fontSize: '10.5px', color: 'var(--muted2)' }}
          >
            Edit in Risk Rules
          </a>{' '}
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          Confirm what is protecting you before the open.
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
            gap: '12px',
            marginTop: '14px',
          }}
        >
          {' '}
          <div
            style={{
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              background: 'var(--l3)',
              padding: '11px 13px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Position rules
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                {dc.t(m.ruleCount)}
              </span>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '6px' }}>
              {' '}
              {(m.prepRules ?? []).map((r, i34) => (
                <Fragment key={i34}>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={r?.toggle}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '9px',
                      padding: '7px 0',
                      border: 'none',
                      background: 'transparent',
                      textAlign: 'left',
                      cursor: 'pointer',
                      borderRadius: '6px',
                    }}
                  >
                    {' '}
                    <i
                      className={`ph ${dc.s(r?.icon)}`}
                      style={dc.css(`font-size:14px;color:${dc.s(r?.iconFg)};flex:none`)}
                    ></i>{' '}
                    <span style={dc.css(`font-size:11.5px;flex:1;min-width:0;color:${dc.s(r?.nameFg)}`)}>
                      {dc.t(r?.name)}
                    </span>{' '}
                    <span style={dc.css(`font-size:10px;color:${dc.s(r?.statusFg)}`)}>
                      {dc.t(r?.status)}
                    </span>{' '}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              background: 'var(--l3)',
              padding: '11px 13px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Session limits
              </span>
              <div style={{ flex: '1' }}></div>
              <span style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                {dc.t(m.limitCount)}
              </span>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '6px' }}>
              {' '}
              {(m.prepLimits ?? []).map((l, i35) => (
                <Fragment key={i35}>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '7px 0' }}>
                    {' '}
                    <i
                      className={`ph ${dc.s(l?.icon)}`}
                      style={dc.css(`font-size:14px;color:${dc.s(l?.iconFg)};flex:none`)}
                    ></i>{' '}
                    <span style={dc.css(`font-size:11.5px;flex:1;min-width:0;color:${dc.s(l?.nameFg)}`)}>
                      {dc.t(l?.name)}
                    </span>{' '}
                    <span
                      style={dc.css(
                        `font-size:11px;color:${dc.s(l?.valFg)};font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(l?.val)}
                    </span>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={dc.css(
            `display:flex;align-items:center;gap:8px;padding-top:9px;margin-top:11px;border-top:1px solid var(--l6);font-size:11px;color:${dc.s(m.engineReadyFg)}`,
          )}
        >
          <i className="ph ph-engine" style={{ fontSize: '13px' }}></i>
          {dc.t(m.engineReadyText)}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          gridColumn: '1/-1',
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {' '}
          <i className="ph ph-note-pencil" style={{ color: 'var(--amb)', fontSize: '16px' }}></i>{' '}
          <span style={{ fontSize: '13px', fontWeight: '500' }}>Pre-Session Notes</span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <span style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
            {dc.t(m.preNoteCount)}
          </span>{' '}
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '5px' }}>
          Write your intent now so the close-of-session review has something to grade against.
        </div>{' '}
        <div
          style={{
            border: '1px solid var(--l8)',
            borderRadius: '11px',
            background: 'var(--l3)',
            padding: '12px 14px',
            marginTop: '14px',
          }}
        >
          {' '}
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Carried from yesterday’s close
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--text-mid)', lineHeight: '1.6', marginTop: '6px' }}>
            Keep the 2-per-session cap on the London playbook and leave Asia alone — the XAU range fade was
            the only red trade of the day.
          </div>{' '}
        </div>{' '}
        <textarea
          value={dc.v(m.preNote)}
          onChange={m.setPreNote}
          placeholder="What am I looking for today, and what would make me stop?"
          style={{
            width: '100%',
            height: '104px',
            resize: 'none',
            marginTop: '11px',
            padding: '11px 13px',
            borderRadius: '10px',
            border: '1px solid var(--l10)',
            background: 'var(--fill)',
            color: 'var(--text)',
            fontSize: '12px',
            lineHeight: '1.6',
            fontFamily: 'inherit',
            outline: 'none',
          }}
          aria-label="What am I looking for today, and what would make me stop?"
        ></textarea>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginTop: '11px' }}>
          {' '}
          {(m.preNoteChips ?? []).map((c, i36) => (
            <Fragment key={i36}>
              {' '}
              <button
                className="scp-2cd95ba"
                onClick={c?.go}
                style={{
                  fontSize: '11px',
                  padding: '6px 13px',
                  borderRadius: '99px',
                  border: '1px dashed var(--l10)',
                  background: 'transparent',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                }}
              >
                {dc.t(c?.label)}
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <button
        className="scp-dce8843"
        style={{
          gridColumn: '1/-1',
          justifySelf: 'end',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '12.5px',
          fontWeight: '500',
          padding: '10px 22px',
          borderRadius: '99px',
          border: '1px solid color-mix(in srgb, var(--amb) 55%, transparent)',
          background: 'color-mix(in srgb, var(--amb) 10%, transparent)',
          color: 'var(--amb)',
          cursor: 'pointer',
        }}
        onClick={m.armSession}
        disabled={dc.b(m.armPending)}
        data-arm-session=""
      >
        <i className="ph ph-play" style={{ fontSize: '14px' }}></i>Start Session
      </button>
      <span hidden id="pf-max-trades-mirror-note">
        Mirrors the Daily Trade Limit risk control — edit it there and this figure follows.
      </span>
    </div>
  );
}
